import GeneralButtonComponent from '../../components/button/GeneralButtonComponent';
import CounterComponent from "../../components/counter/CounterComponent";
import { SliderContainer } from "../../components/swipper/SliderContainer";
import SpaBuildDetailComponent from "./SpaBuildDetailComponent";


const TipoMasaje = () => {
    return (
        <div className='card-detail-experience rounded-lg shadow-xl'>

            <div style={{ color: '#67BAAF', fontSize: '16px' }}>
                Oxigenoporación:
            </div>

            <p className='mt-2' style={{ color: '#4B5563' }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ac justo nulla. Fusce vestibulum purus lobortis tortor eleifend, quis laoreet nulla efficitur.
            </p>

            <div className="grid grid-cols-3 gap-3 mt-4">
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#67BAAF' >11:00 a.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >12:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >01:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >02:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >05:00 p.m.</GeneralButtonComponent>
                </div>
                <div className='place-self-center'>
                    <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 fs-12' bgcolor='#B3D0CC' textcolor='#2D5752' >06:00 p.m.</GeneralButtonComponent>
                </div>
            </div>

            <div className="mt-8">Personas:</div>
            <div className='flex justify-between items-center mt-1'>
                <CounterComponent />
                <div className='text-right'>
                    <span>Por persona</span>
                    <br />
                    <span className='total_price_lg'>USD $100</span>
                </div>
            </div>
        </div>
    )
}

const SpaCardComponent = () => {
    return (
        <>
            <SliderContainer>
                <TipoMasaje />
                <TipoMasaje />
            </SliderContainer>
            <SpaBuildDetailComponent />

            <div className='flex justify-between items-center mt-4'>
                <div className='text-right'>
                    <span>Total</span>
                    <br />
                    <span className='total_price_lg'>USD $100</span>
                </div>

                <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-4 he-50' bgcolor='#67BAAF' > Reservar</GeneralButtonComponent>
            </div>
        </>
    )
}

export default SpaCardComponent;
